import PropTypes from 'prop-types';
import isPropValid from '@emotion/is-prop-valid';
import { LazyMotion, MotionConfig, domMax, m } from 'motion/react';

// ----------------------------------------------------------------------

function MotionLazy({ children }) {
  return (
    <MotionConfig isValidProp={isPropValid}>
      <LazyMotion strict features={domMax}>
        <m.div style={{ height: '100%' }}> {children} </m.div>
      </LazyMotion>
    </MotionConfig>
  );
}

MotionLazy.propTypes = {
  children: PropTypes.node,
};

export default MotionLazy;
